export const RESUME_ERROR_LABEL = "resume"
export const CERTIFICATES_ERROR_LABEL = "certificates"
export const EMPLOYMENT_ERROR_LABEL = "employment"